








































import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../domain";
import { IEmbeddedFormatSelectionResult, IEmbeddedSelectedFormat } from "../../domain/document";
import { FormatReference } from "../../domain/format";
import MultiOrderableFormatListSelector from "../../components/format/selectors/MultiOrderableFormatListSelector.vue";

@Component({
  components: {
    MultiOrderableFormatListSelector,
  },
})
export default class EmbeddedMultiFormatListSelectorView extends Mixins() {
  @Prop({ default: false })
  isExpiredFilterEnable: boolean;

  @Prop({ default: false })
  isDeletedFilterEnable: boolean;

  @Prop({ default: false })
  shouldIgnoreChained: boolean;

  @Prop({ default: false })
  isDefaultMultiSelect: boolean;

  @Prop()
  formatIds: number[];

  data(): any {
    return {
      selectedFormats: null,
    };
  }
  visibleTabs: any[] = MultiOrderableFormatListSelector.formatTabs;
  selectedFormats: FormatReference[];

  async mounted() {
    if (this.formatIds && this.formatIds.length > 0) {
      this.selectedFormats = await this.getFormatReferences(this.formatIds);
    }
  }

  get selectionMaxCount(): number {
    return this.$configuration.behavior.format.multiSelector.max;
  }

  get additionMaxCount(): number {
    return this.$configuration.behavior.format.multiSelector.addition.max;
  }

  get hasSelected(): boolean {
    return (Array.isArray(this.selectedFormats) ? this.selectedFormats.length > 0 : !!this.selectedFormats);
  }

  get isSelectable(): boolean {
    return this.hasSelected && !this.isOverSelectionMaxCount;
  }

  get isOverSelectionMaxCount(): boolean {
    return this.selectedFormats && this.selectedFormats.length > this.selectionMaxCount;
  }

  get isMultiSelect(): boolean {
    return this.isDefaultMultiSelect || (this.formatIds && this.formatIds.length > 1);
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  onFormatsSelected(selectedFormats: FormatReference[]): void {
    this.select(selectedFormats);
  }

  select(selected?: FormatReference[]): void {
    if (selected) {
      this.selectedFormats = selected;
    }
    this.notifyMessage(this.createResultMessage(true, Enumerable.from(this.selectedFormats).select(s => this.toEmbeddedSelectedFormat(s)).toArray()));
  }

  private toEmbeddedSelectedFormat(format: FormatReference): IEmbeddedSelectedFormat {
    return {
      id: format.id,
      name: format.name,
    };
  }

  clear(): void {
    this.notifyMessage(this.createResultMessage(true, null as IEmbeddedSelectedFormat[]));
  }

  cancel(): void {
    this.notifyMessage(this.createResultMessage(false, null as IEmbeddedSelectedFormat[]));
  }

  createResultMessage(isSelected: boolean, formats: IEmbeddedSelectedFormat[]): IEmbeddedFormatSelectionResult {
    return {
      request: "notify-formats-selected",
      isSelected: isSelected,
      formats: formats,
    };
  }

  notifyMessage(result: IEmbeddedFormatSelectionResult): void {
    try {
      if (window.parent) {
        window.parent.postMessage(JSON.stringify(result), "*");
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getFormatReferences(formatIds: number[]): Promise<FormatReference[]> {
    try {
      const repository = DomainRegistry.format.getFormatRepository();
      const formats = await repository.getFormatReferences(formatIds);
      return formats;
    } catch (e) {
      this.$error(this.formatNameWording + "取得失敗", this.formatNameWording + "取得中にエラーが発生しました。", e);
      return null;
    }
  }
}
